export default [
  {
    path: "/team-content-view",
    name: "team-content-view",
    meta: { title: "Team-Content-View" },
    component: () => import("../views/team_content/team-content-view.vue")
  },
]